/**
 * Route path constants for the application
 * Centralized route definitions for easy maintenance
 */
import { isDemoMode } from '@/config/demo';
import { isBillingEnabled } from '@/config/features';

// Public routes (no authentication required)
export const PUBLIC_ROUTES = {
  LOGIN: '/login',
  REGISTER: '/register',
  PORTFOLIO: '/portfolio',
  AUTH_CALLBACK: '/auth/callback',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
} as const;

// Protected routes (authentication required)
export const PROTECTED_ROUTES = {
  HOME: '/',
  CHAT: '/ai-chat',
  ORDERS: '/orders',
  SETTINGS: '/settings',
  SETTINGS_PAYMENT: '/settings/payment',
  SUBSCRIPTION: '/subscription',
  SUBSCRIPTION_SUCCESS: '/subscription/success',
  SUBSCRIPTION_CANCEL: '/subscription/cancel',
  // Admin routes
  ADMIN: '/admin',
  ADMIN_USERS: '/admin/users',
  ADMIN_SETTINGS: '/admin/settings',
} as const;

// Default route after successful login
export const DEFAULT_AUTHENTICATED_ROUTE = PROTECTED_ROUTES.HOME;

// 402 付費牆攔截時，暫存待顯示 toast 訊息的 sessionStorage key。
// 跳轉 /subscription 後由 ManageSubscriptionPage 讀出顯示，避免整頁 reload 把 toast 清掉。
export const PAYWALL_TOAST_STORAGE_KEY = 'paywall:pendingToast';

// 訂閱入口顯示判斷：金流總開關開啟（或 Demo 模式）即對所有登入使用者開放
export const isSubscriptionAllowed = (): boolean => {
  if (isDemoMode) return true;
  return isBillingEnabled; // 總開關關閉 → 一律隱藏訂閱入口
};
